import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { contactFilesWithPresignedUrlsStateForIdsSelector } from '../contact-file-selectors';

import * as Api from '../../api/api';

export const loadContactFilePresignedUrls = (contactFileIds: number[]) =>
  createGenericDispatcher<
    Array<{ contactFileId: number; presignedUrl: string; expiresAt: Date }[]>
  >({
    name: 'LOAD_CONTACT_FILE_PRESIGNED_URLS',
    loadFunction: () =>
      Api.post(`/contact-file/presigned-urls`, {
        body: JSON.stringify({ contactFileIds }),
      }),
    args: { contactFileIds },
    shouldExecuteSelector: (state: any) =>
      contactFilesWithPresignedUrlsStateForIdsSelector(state, contactFileIds),
  });
